
import HeroHome from '../../components/HeroComponents/HeroHome'
import Team from "../../components/Team";
import Testimonial from "../../components/Testimonial";
import Projects from "../../components/Projects";
import Newletter from "../../components/Newletter";
import Service from "../../components/Service";
import Facts from "../../components/Facts";
import About from "../../components/About";
import Feature from "../../components/Feature";


function Home() {
    return (
        <>
            <HeroHome />
            {/* Feature Start */}
            <Feature />
            {/* Feature End */}
            {/* About Start */}
            <About />
            {/* About End */}
            {/* Facts Start */}
            <Facts />
            {/* Facts End */}
            {/* Service Start */}
            <Service />
            {/* Service End */}
            {/* Newsletter Start */}
            <Newletter />
            {/* Newsletter End */}
            {/* Projects Start */}
            <Projects />
            {/* Projects End */}
            {/* Testimonial Start */}
            {/* <Testimonial /> */}
            {/* Testimonial End */}
            {/* Team Start */}
            <Team />
            {/* Team End */}

            
          
        </>
    )
}

export default Home